import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApiData } from '../../../store/slicers/apiSlicer.js';

const Carousel = () => {
  const dispatch = useDispatch();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([]);

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.slides,
    isLoading: state.apiData?.loading?.slides
  }));

  useEffect(() => {
    dispatch(fetchApiData({ url: 'slides', itemKey: 'slides' }));
  }, []);

  useEffect(() => {
    if (data?.data) {
      setSlides(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (slides.length > 0) {
      const interval = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % slides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [slides.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  if (isLoading) {
    return (
      <div className="carousel-container">
        <div className="carousel-placeholder">
          <div className="placeholder-content">
            <i className="pi pi-spin pi-spinner" style={{fontSize: '3rem'}}></i>
            <p>Chargement du carousel...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!slides || slides.length === 0) {
    return (
      <div className="carousel-container">
        <div className="carousel-placeholder">
          <div className="placeholder-content">
            <i className="pi pi-images" style={{fontSize: '3rem'}}></i>
            <p>Aucune image disponible</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <div className="carousel">
        <div className="carousel-slides" style={{transform: `translateX(-${currentSlide * 100}%)`}}>
          {slides.map((slide) => (
            <div key={slide.id} className="carousel-slide" style={{backgroundImage: `url(${slide.image})`}}>
              <div className="slide-caption">
                <h2>{slide.title}</h2>
                <p>{slide.image_description || ''}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="carousel-controls">
          <button className="carousel-btn" onClick={prevSlide}>‹</button>
          <button className="carousel-btn" onClick={nextSlide}>›</button>
        </div>
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <div key={index} className={`indicator ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
